/**
 * Internal error used to short-circuit parser code before transport wraps it
 * into one public contract error value.
 */
export class ContractViolationError extends Error {
    path;
    constructor(path, message) {
        super(message);
        this.name = "ContractViolationError";
        this.path = path;
    }
}
/**
 * Throw one internal contract-violation error.
 */
export function failContract(path, message) {
    throw new ContractViolationError(path, message);
}
//# sourceMappingURL=errors.js.map